import { lazy, Suspense, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import KakaoFloatingButton from "@/components/KakaoFloatingButton";
import HeroSection from "@/components/sections/company-v2/HeroSection";
import BrandIntroSection from "@/components/sections/company-v2/BrandIntroSection";
import BrandIdentityBoardSection from "@/components/sections/company-v2/BrandIdentityBoardSection";
import AboutSection from "@/components/sections/company-v2/AboutSection";
import CoreValueSection from "@/components/sections/company-v2/CoreValueSection";
import ServiceSection from "@/components/sections/company-v2/ServiceSection";
import ProcessSection from "@/components/sections/company-v2/ProcessSection";
import WhySection from "@/components/sections/company-v2/WhySection";
import BusinessAreaSection from "@/components/sections/company-v2/BusinessAreaSection";
import VisionSection from "@/components/sections/company-v2/VisionSection";
import CTASection from "@/components/sections/company-v2/CTASection";
import AboutFaqSection from "@/components/sections/company-v2/AboutFaqSection";
import { getKakaoChannelUrl, useCms } from "@/lib/cms";
import { openContactForm } from "@/lib/contactForm";
import "@/components/sections/company-v2/company-v2.css";

const ChatbotWidget = lazy(() => import("@/components/ChatbotWidget"));

export default function AboutPage2() {
  const location = useLocation();
  const { cms } = useCms();
  const kakaoChannelUrl = getKakaoChannelUrl(cms);

  useEffect(() => {
    document.body.classList.add("ds-company-v2-page-active");
    return () => document.body.classList.remove("ds-company-v2-page-active");
  }, []);

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      return undefined;
    }

    const id = location.hash.slice(1);
    let cancelled = false;
    let attempts = 0;

    const scrollToHash = () => {
      if (cancelled) return;
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({ behavior: "smooth" });
        return;
      }
      if (attempts < 24) {
        attempts += 1;
        requestAnimationFrame(scrollToHash);
      }
    };

    requestAnimationFrame(scrollToHash);
    return () => {
      cancelled = true;
    };
  }, [location.pathname, location.hash]);

  return (
    <main
      data-testid="about-page-2"
      className="ds-company-v2-page min-h-screen bg-white text-slate-900 relative w-full max-w-[100vw] overflow-x-clip"
    >
      <Header />
      <HeroSection onContact={openContactForm} />
      <BrandIntroSection />
      <BrandIdentityBoardSection />
      <AboutSection />
      <CoreValueSection />
      <ServiceSection />
      <ProcessSection />
      <WhySection />
      <BusinessAreaSection />
      <VisionSection />
      <AboutFaqSection />
      <CTASection onContact={openContactForm} kakaoChannelUrl={kakaoChannelUrl} />
      <Footer />
      <KakaoFloatingButton />
      <Suspense fallback={null}>
        <ChatbotWidget />
      </Suspense>
    </main>
  );
}
